import Axios from "../axios";
import { createContext, useContext, useEffect, useState } from "react";
import { UserContext } from "./userContext";
import { useDispatch } from "react-redux";
import { track } from "@amplitude/analytics-browser";

const CustomElementsContext = createContext();

const CustomElementsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { flimpID, userID, sessionID } = useContext(UserContext);
  const [customButtons, setCustomButtons] = useState([]);
  const [customButtonFilter, setCustomButtonFilter] = useState("createdAt");
  const [postStatus, setPostStatus] = useState(null);
  const [updateStatus, setUpdateStatus] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState(null);
  const [getStatus, setGetStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getCustomButtons = (type, filter) => {
    Axios.CustomElementsService.GET_CUSTOM_ELEMENTS({
      type: type,
      filter: filter,
      userID: userID,
    })
      .then((res) => {
        if (res) {
          setCustomButtons(res.data.data);
        }
      })
      .catch((err) => {
        setGetStatus(err);
      })
      .finally(() => {});
  };

  const postCustomButton = (button) => {
    const data = {
      user_id: userID,
      flimp_id: flimpID,
      custom_element_type: "Button",
      custom_element_name: button.custom_element_name,
      custom_element_json: JSON.stringify(button.custom_element_json),
    };
    const jsonDATA = JSON.stringify(data);

    Axios.CustomElementsService.POST_CUSTOM_ELEMENT(jsonDATA)
      .then((res) => {
        if (res && res.data.statusMessage == "Success") {
          setIsLoading(true);
          setCustomButtons([
            ...customButtons,
            {
              ...data,
              custom_element_json: {
                ...button.custom_element_json,
                customElementID: res.data.customElementID,
              },
              customElementID: res.data.customElementID,
            },
          ]);
          setPostStatus("Success");
        }
        if (res && res.data.statusMessage !== "Success") {
          setPostStatus("error");
          setTimeout(() => {
            setPostStatus(null);
          }, 3000);
        }
      })
      .catch((e) => {
        setPostStatus("error");
        setTimeout(() => {
          setPostStatus(null);
        }, 3000);
      })
      .finally(() => {
        track("GlobalStyleCreated", {
          styleName: button.custom_element_name,
          creationDate: new Date(),
        });
        setTimeout(() => {
          setPostStatus("");
          setIsLoading(false);
        }, 2000);
        getCustomButtons("Button", customButtonFilter);
      });
  };
  const updateCustomButton = (updatedButton) => {
    const data = {
      custom_element_type: "Button",
      custom_element_name: updatedButton.custom_element_json.customElementName,
      custom_element_json: JSON.stringify(updatedButton.custom_element_json),
    };

    const jsonDATA = JSON.stringify(data);
    Axios.CustomElementsService.UPDATE_CUSTOM_ELEMENT(
      updatedButton.customElementID,
      data
    )
      .then((res) => {
        if (res && res.data.statusMessage == "Success") {
          setIsLoading(true);
          let updatedElementID = updatedButton.customElementID;
          let newCustomButtons = customButtons.map((button) => {
            if (button.customElementID == updatedElementID) {
              return updatedButton;
            } else {
              return button;
            }
          });
          setCustomButtons(newCustomButtons);
          setUpdateStatus("Success");
        }
        if (res && res.data.statusMessage !== "Success") {
          setUpdateStatus("error");
          setTimeout(() => {
            setUpdateStatus(null);
          }, 3000);
        }
      })
      .catch((err) => {
        setUpdateStatus("error");
        setTimeout(() => {
          setUpdateStatus(null);
        }, 3000);
      })
      .finally(() => {
        track("GlobalStyleModified", {
          styleName: updatedButton.custom_element_json.customElementName,
          modificationDate: new Date(),
        });
        setTimeout(() => {
          setUpdateStatus("");
          setIsLoading(false);
        }, 2000);
        getCustomButtons("Button", customButtonFilter);
      });
  };
  const deleteCustomButton = (deletedButton) => {
    const id = deletedButton.customElementID;
    Axios.CustomElementsService.DELETE_CUSTOM_ELEMENT(id)
      .then((res) => {
        if (res && res.data.statusMessage == "Success") {
          setIsLoading(true);
          let newCustomButtons = customButtons.filter((button) => {
            return button.customElementID !== id;
          });
          setCustomButtons(newCustomButtons);
          setDeleteStatus("Success");
        }
        if (res && res.data.statusMessage !== "Success") {
          setDeleteStatus("error");
        }
      })
      .catch((err) => {
        setDeleteStatus("Success");
      })
      .finally(() => {
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      });

    // setIsLoading(true);
    // let deletedElementID = deletedElement.customElementID;
    // let newCustomElements = customElements[deletedElement.data].filter(
    //   (element) => {
    //     return element.customElementID !== deletedElementID;
    //   }
    // );
    // setCustomButtons({
    //   ...customElements,
    //   [deletedElement.data]: newCustomElements,
    // });
  };
  const saveCustomButton = (button) => {
    var updating = false;
    button.customElementID == null ? (updating = false) : (updating = true);

    if (updating == false) {
      postCustomButton(button);
    } else {
      updateCustomButton(button);
    }
  };

  useEffect(() => {
    if (flimpID) {
      try {
        getCustomButtons("Button", customButtonFilter);
      } catch (error) {}
    }
  }, [flimpID]);

  return (
    <CustomElementsContext.Provider
      value={{
        customButtons,
        getStatus,
        postStatus,
        updateStatus,
        deleteStatus,
        isLoading,
        deleteCustomButton,
        saveCustomButton,
        setCustomButtons,
        postCustomButton,
        getCustomButtons,
        setCustomButtonFilter,
        customButtonFilter,
      }}
    >
      {children}
    </CustomElementsContext.Provider>
  );
};

export { CustomElementsContext, CustomElementsProvider };
